module.exports = __webpack_public_path__ + "img/沙尘暴.5d4ebc9a.png";